/* Native Shopify forms work without JavaScript. Keep enhancement local and small. */
document.querySelectorAll('form[action*="/cart/add"]').forEach((form) => {
  form.addEventListener('submit', () => {
    const button = form.querySelector('button[name="add"]');
    if (button && form.checkValidity()) {
      button.setAttribute('aria-busy', 'true');
      button.textContent = 'Adding to your basket…';
    }
  });
});
window.addEventListener('pageshow', () => {
  document.querySelectorAll('button[name="add"][aria-busy="true"]').forEach((button) => {
    button.removeAttribute('aria-busy');
    button.textContent = 'Add to basket';
  });
});
